import { Checkbox, Flex, ScrollArea, Table, Text } from '@mantine/core';
import { ProdoqPermissionKey, ProdoqPermissionYn } from '../../../../../../shared/types/prodoq';

export interface IPermissionGrantRow {
  roleId: number;
  roleName: string;
  read: ProdoqPermissionYn;
  create: ProdoqPermissionYn;
  update: ProdoqPermissionYn;
  delete: ProdoqPermissionYn;
}

interface PermissionGrantTableProps {
  permissions: IPermissionGrantRow[];
  selectedMenuId: number | null;
  onChangePermission: (roleId: number, permissionKey: ProdoqPermissionKey, checked: boolean) => void;
}

const PERMISSION_COLUMNS: Array<{
  key: ProdoqPermissionKey;
  label: string;
}> = [
  {
    key: 'read',
    label: '조회',
  },
  {
    key: 'create',
    label: '등록',
  },
  {
    key: 'update',
    label: '수정',
  },
  {
    key: 'delete',
    label: '삭제',
  },
];

export default function PermissionGrantTable(props: PermissionGrantTableProps) {
  const { permissions, selectedMenuId, onChangePermission } = props;
  const disabledPermissionMenuIds = [5, 7, 8];
  const isReadOnlyPermissionMenu = disabledPermissionMenuIds.includes(selectedMenuId ?? -1);

  return (
    <ScrollArea mah={260} type="auto" offsetScrollbars>
      <Table stickyHeader>
        <Table.Thead>
          <Table.Tr>
            <Table.Th />
            {PERMISSION_COLUMNS.map((column) => (
              <Table.Th key={column.key} ta="center">
                {column.label}
              </Table.Th>
            ))}
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {permissions.map((permission) => (
            <Table.Tr key={permission.roleId}>
              <Table.Td ta="left" maw={100}>
                <Text size="sm" truncate>
                  {permission.roleName}
                </Text>
              </Table.Td>
              {PERMISSION_COLUMNS.map((column) => (
                <Table.Td key={column.key}>
                  <Flex justify="center">
                    <Checkbox
                      disabled={isReadOnlyPermissionMenu}
                      checked={permission[column.key] === 'Y'}
                      onChange={(event) => onChangePermission(permission.roleId, column.key, event.currentTarget.checked)}
                    />
                  </Flex>
                </Table.Td>
              ))}
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </ScrollArea>
  );
}
